import {Pipeline} from "./pipeline.mjs";


export class DataTransformer{
    constructor(){
        var _pipeline = new Pipeline();

        Object.defineProperty(this,'add',{
            value : _pipeline.add
        });

        Object.defineProperty(this,'run',{
            value : _pipeline.run
        });
    }
    // ==========
    // private 
    // ----------
    getPipeline(){ return this.pipeline }

    // ==========
    // public 
    // ----------
    transform(data){ return this.run(data) }
}

export class DataTransformerOptions{
    constructor(){}
}